// frontend/src/stores/spaNotificationStore.js
import { create } from 'zustand';

const useSpaNotificationStore = create((set) => ({
  newBookingCounts: {},
  incrementNewBookingCount: (propertyId) =>
    set((state) => ({
      newBookingCounts: {
        ...state.newBookingCounts,
        [propertyId]: (state.newBookingCounts[propertyId] || 0) + 1,
      },
    })),
  clearNewBookingCount: (propertyId) =>
    set((state) => {
      if (!state.newBookingCounts[propertyId]) return {};
      return {
        newBookingCounts: {
          ...state.newBookingCounts,
          [propertyId]: 0,
        },
      };
    }),
}));

export default useSpaNotificationStore;